import { useContext } from 'react';

import { FormIssue } from './components';

import { ConfirmIssueQuotation, QuotationInfoContext } from '../../../shared';

export const StepFour = () => {
  const { canShowConfirmIssue } = useContext(QuotationInfoContext);

  return canShowConfirmIssue ? <ConfirmIssueQuotation />: <FormIssue />
};
